"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrideReasonToJSON = exports.OverrideReasonFromJSONTyped = exports.OverrideReasonFromJSON = exports.OverrideReason = void 0;
/**
 * Override reason to know if the Biometrics were overridden
 * @export
 * @enum {string}
 */
var OverrideReason;
(function (OverrideReason) {
    OverrideReason["ALTEREDTOMEETTSANAMEREQUIREMENTS"] = "ALTERED_TO_MEET_TSA_NAME_REQUIREMENTS";
    OverrideReason["MULTIPLENAMESINASINGLEFIELD"] = "MULTIPLE_NAMES_IN_A_SINGLE_FIELD";
    OverrideReason["NAMETRUNCATED"] = "NAME_TRUNCATED";
    OverrideReason["OCRINCORRECT"] = "OCR_INCORRECT";
})(OverrideReason = exports.OverrideReason || (exports.OverrideReason = {}));
function OverrideReasonFromJSON(json) {
    return OverrideReasonFromJSONTyped(json, false);
}
exports.OverrideReasonFromJSON = OverrideReasonFromJSON;
function OverrideReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.OverrideReasonFromJSONTyped = OverrideReasonFromJSONTyped;
function OverrideReasonToJSON(value) {
    return value;
}
exports.OverrideReasonToJSON = OverrideReasonToJSON;
//# sourceMappingURL=OverrideReason.js.map